import { Component } from '@angular/core';

@Component({
  selector: 'sh-platform-rangepicker',
  templateUrl: './platform-rangepicker.component.html',
  standalone: false
})
export class PlatformRangepickerComponent {
  constructor() {}
}
